module.exports = __webpack_public_path__ + "img/icn.db897f35.svg";